/**
 * Centralized company information for Airon AS.
 *
 * Every hard-coded address, phone, email and opening-hours reference in the
 * site should import from here. That way when Promang (CMS) exposes a
 * `/company/info` endpoint in the future, we only need to wire up
 * `useCompanyInfo()` below to read from the API and the whole site updates.
 */

export const COMPANY = {
  name: "Airon AS",
  tagline:
    "Balansert ventilasjon, service og kanalrens — for bolig, næring og industri.",
  phone: {
    display: "+47 69 14 26 00",
    tel: "+4769142600",
  },
  email: "post@airon.no",
  address: {
    street: "Trøskenveien 36",
    postal: "1712",
    city: "Grålum",
    region: "Sarpsborg",
    // Full human-readable line
    full: "Trøskenveien 36, 1712 Grålum",
    // Short chip-style location used in the topbar
    short: "Grålum, Sarpsborg",
  },
  hours: {
    // Short line used in the topbar
    short: "Man–Tor 08:00–15:00 · Fre 08:00–13:00",
    lines: [
      { day: "Mandag – Torsdag", time: "08:00 – 15:00" },
      { day: "Fredag", time: "08:00 – 13:00" },
    ],
  },
  social: {
    facebook: "https://www.facebook.com/aironventilasjonas/",
  },
  legal: {
    orgNumber: null, // Populate if/when known
    jurisdiction: "Sarpsborg Byrett",
  },
};

/**
 * Hook-like accessor for company info. Today it just returns the static
 * COMPANY constant, but leaves room for a future Promang fetch (e.g.
 * `/company/info`) without changing call sites.
 */
export function useCompanyInfo() {
  return COMPANY;
}
